import React, { useState, useRef, useEffect } from "react";
import { Grid, Button, TextField } from "@material-ui/core";
import { checkSupportedFormat } from "utils/common";
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { useStyles } from "./style";
import Clear from "@material-ui/icons/Clear";
import _ from "lodash";


export default function InstructionTab(props) {

    const { labDetails } = props;
    const content = labDetails && labDetails.content;
    const video_instruction = labDetails && labDetails?.video_instruction;
    const valuesArray = video_instruction?.split(',').map((value) => value.trim());
    const [videoArray, setVideoArray] = useState([]);
    const [fileName, setFileName] = useState(content);
    const [videoUrl, setVideoUrl] = useState("");
    const classes = useStyles();
    const supportedFileTypes = ["pdf"];
    const videoRef = useRef(null);

    const createFormPayload = async (event, file) => {
        setFileName(file?.name)
        const pdfFile = file;
        props?.bindFileData(pdfFile);

    }

    useEffect(() => {
        if(_.isEmpty(videoArray)){
            if(video_instruction !== "undefined" && !_.isEmpty(video_instruction)){
                const valuesArray = video_instruction?.split(',').map((value) => value.trim()) || [];
                setVideoArray(valuesArray)
            }
        }
    }, [video_instruction]);

    const fileUpload = async (event) => {
        try {
            for (var index = 0; index < event.target.files.length; index++) {
                const file = event.target.files[index];
                const isValidFormat = checkSupportedFormat(file.name, supportedFileTypes);
                if (isValidFormat) {
                    await createFormPayload(event, file);
                }
                else {
                    toast.error(`${file.name} file's format not supported.`);
                }
            }

        } catch (error) {
            console.log(error);
        }
    }

    const fileClick = (evt) => evt.target.value = '';

    const openFileInNewTab = (url) => {
        window.open(url, '_blank').focus();
    }

    const uploadVideo = () => {
        if(!_.isEmpty(videoUrl)){
            videoRef.current = videoUrl;
            const newVideoArray =  videoUrl?.split(',').map((value) => value.trim()) || videoUrl
            setVideoArray([...videoArray,...newVideoArray]);
            props.bindVideoData([...videoArray,...newVideoArray].join(","));
        }else{
            toast.error(`Can not upload empty URL.`);
        }
       
    }

    const removeVideoUrl = (index) => {
        const newArray = [...videoArray];
        newArray.splice(index, 1);
        setVideoArray(newArray);
        props.bindVideoData(newArray.join(','));
    }

    
    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={2} style={{ paddingTop: "26px" }}>
                    <Button
                        variant="contained"
                        component="label"
                    >
                        Upload File
                        <input
                            type="file"
                            multiple
                            hidden
                            onClick={(e) => fileClick(e)}
                            onChange={(e) => fileUpload(e)}
                        />
                    </Button>
                </Grid>
                <Grid item xs={4} >
                    <TextField
                        fullWidth
                        name="video"
                        label="Video Url"
                        variant="outlined"
                        disabled={false}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setVideoUrl(e.target.value)

                        }}
                        value={videoUrl}
                        ref={videoRef}
                    >
                    </TextField>

                </Grid>
                <Grid item xs={2} style={{ paddingTop: "26px" }}>
                    <Button
                        variant="contained"
                        component="label"
                        onClick={uploadVideo}
                    >
                        Upload Video
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={12} style={{ padding: "20px" }}>
                <Grid item xs={4}>
                    {
                        !_.isEmpty(fileName || content) ? <>
                            <div key={uuid()} style={{ display: 'flex', marginBottom: 6, gap: 10 }}>
                                {
                                    !_.isEmpty(fileName) ?
                                        <div style={{ padding: "10px" }} >{fileName}</div>
                                        : <div className={classes.fileName} style={{ padding: "10px" }} onClick={() => openFileInNewTab(content)}>{content?.split(".pdf")[0]?.split("/")[6]}</div>
                                }

                            </div>
                        </> : <></>
                    }
                </Grid>
                <Grid item xs={4}>
                    {
                        videoArray?.length > 0  ?
                        videoArray?.map((item, index) => (
                                <><div style={{ padding: "10px" }} key={index} className={classes.fileName}>{item}<Clear className={classes.clearIcon} onClick={() => {removeVideoUrl(index)}} /></div></>
                            )) : <></>
                    }
                </Grid>

            </Grid>

        </>
    )
}

